import Article from './article';
import Transfert from './transfert';
import Stock from './stock';
import Mouvement from './mouvement';

export default [...Article, ...Transfert, ...Stock, ...Mouvement];
